export const MAPS_API_KEY = 'AIzaSyCEmgofudNPp7jIJl9smvfpzbasryeld48'
